import { useEffect } from "react";
import { MidiPad } from "./MidiPad";

export const PadGrid = ({ instrument, className, selectedPad, setSelectedPad, arePadsGrouped, setArePadsGrouped }) => {
    useEffect(()=> {
        document.addEventListener("midiNote-" + instrument.id , (evt) => {
            if (evt.detail.source !== "user") return; // could be the sequencer
            if (evt.detail.type == 'noteOff') return;
            setSelectedPad(evt.detail.pitch % 16)
        });
    })
   
    return (
        <div data-widget-id="padGrid" className={`pad-grid ${className}`}>
            <button data-widget-id="padsGroupToggle" className={`col-span-full p-2 btn ${arePadsGrouped ? "active" : ""}`} onClick={() => setArePadsGrouped(v => !v)}>GROUP</button>
            {Array.from({ length: 16 }).map((_, index) => {
                // Modifiquem la posició amb l'estil i no amb el DOM
                // Perquè el tab order es mantengui bé
                const col = index % 4 + 1;
                const row = 5 - Math.floor(index / 4);
                return <MidiPad
                    style={{gridRowStart: row, gridColumnStart: col}}
                    className="sampler-pad"
                    key={index}
                    instrument={instrument}
                    pitch={index}
                    isSelected={selectedPad===index}
                    setSelected={() => setSelectedPad(index)}
                    label={index + 1}
                />
            })}
        </div>
    );
};